import { useEffect, useRef, useState } from "react";
import { useTabletAndBelowMediaQuery } from "shared/store/responsiveStore";
import useAppStatus from "shared/store/appStatusStore";

export const TableWrapper = ({ children }) => {
  const containerRef = useRef(null);
  const [width, setWidth] = useState("100%");
  const appStatus = useAppStatus((state) => state.appStatus);
  const windowW = useAppStatus((state) => state.windowW);
  const isTabletOrBelow = useTabletAndBelowMediaQuery();

  useEffect(() => {
    if (isTabletOrBelow) return;

    let adaptChatMainResize = windowW < 1050 ? 1071 : windowW;
    let containerWidth = adaptChatMainResize - 95 + 30 - 520;
    if (appStatus === "idle") {
      adaptChatMainResize = windowW < 650 ? 671 : windowW;
      containerWidth = adaptChatMainResize - 95 - 90;
    }
    setWidth(`${containerWidth}px`);
  }, [appStatus, windowW, isTabletOrBelow]);

  return (
    <div ref={containerRef} className="w-full">
      <div style={{ width, overflow: "auto" }}>
        <table className="min-w-full">{children}</table>
      </div>
    </div>
  );
};
